import React from 'react'

export type MenuItemProps = {
    children?: React.ReactNode
}

export const MenuItem: React.FC<MenuItemProps> = (props) => {
    const { children } = props

    return (
        <div className="rounded-3xl border py-1 px-4 cursor-pointer transition transition-duration-300 hover:bg-blue-500 hover:text-white dark:border dark:border-gray-300 dark:border-opacity-10">
            {children}
        </div>
    )
}
